"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../node");
const signature_1 = require("../signature");
const calc_graph_1 = require("../calc-graph");
class CalculatedFieldNode extends node_1.default {
    static from(obj) {
        if (obj['type'] === 'calculatedField')
            return new CalculatedFieldNode(obj['name'], (0, calc_graph_1.default)(obj['calculation']));
        return null;
    }
    constructor(fieldName, calculation) {
        super('Calculated field node');
        this.fieldName = fieldName;
        this.calculation = calculation;
    }
    checkPort(portNumber) {
        return portNumber === 0;
    }
    getSignature(datasetRepo) {
        if (!this.incoming[0])
            return null;
        let signature = this.incoming[0].getSignature(datasetRepo);
        signature.columns.push(new signature_1.ColumnSignature(this.name, this.id));
        return signature;
    }
    validate(datasetRepo) {
        if (!this.incoming[0] || !this.calculation)
            return false;
        if (!this.calculation.validate())
            return false;
        let signature = this.incoming[0].getSignature(datasetRepo);
        for (let column of this.calculation.listColumns()) {
            if (!signature.containsColumn(column))
                return false;
        }
        return this.incoming[0].validate(datasetRepo);
    }
    serialize() {
        return super.serialize({
            type: 'calculatedField',
            name: this.fieldName,
            calculation: this.calculation,
        });
    }
}
exports.default = CalculatedFieldNode;
